import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/components/shared/main.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import { SharedService } from '../../shared/shared.service';
import { ChatSupportService } from '../../shared/chat-support.service';
import { ApiService } from '../../shared/api.service';
import { localStorageService } from '../../shared/localstorage.service';
import { SocketsService } from '../../shared/socket/socket.service';

@Component({
  selector: 'app-support-chat',
  templateUrl: './support-chat.component.html',
  styleUrls: ['./support-chat.component.scss'],
})
export class SupportChatComponent implements OnInit {
  hideFieldsForOthers: any = false;
  createTicketInProgress: any = false;
  recentchatData: any;
  userdataStats: any;
  shimmer: boolean = false;
  userId: any;
  activeUserId: number | null = null; // Track the active user ID
  user_status: any = 'Offline';
  sub: any;
  sub2: any;
  userData: any;
  timezoneName: any = localStorage.getItem('timezoneName');
  timezone: any = localStorage.getItem('timezone');
  paymentLink: any;
  @ViewChild('genratePaymentLinkModal') public genratePaymentLinkModal: any;
  @ViewChild('sendNotificationModal') public sendNotificationModal: any;
  sendEmailValue: any;
  sendSmsValue: any;
  isAuthenticate: any;
  subPayLink: boolean = false;
  boosterPayLink: boolean = false;
  dial_code: any = '+1';
  phone_number: any;
  email: any;
  linkExpireTime: any;
  readChatShow: boolean = false;
  selectedPaymentType = -1;
  paymentTypeArray: any = [
    { text: 'Select Subscription Type', id: -1 },
    // { text: 'Dispute', id: 1 },
    { text: 'Subscription (Monthly/Yearly)', id: 4 },
    { text: 'Monthly Subscription', id: 2 },
    { text: 'Yearly Subscription', id: 3 },
    { text: 'Upgrade Subscription', id: 5 },
  ];

  chatTypeArray: any = [
    {
      text: 'Business',
      panel_type: 1,
      new_msg_count: 0,
      icon: 'assets/images/chatbot/inbox-icon.svg',
    },
    {
      text: 'Request',
      panel_type: 4,
      new_msg_count: 0,
      icon: 'assets/images/chatbot/inbox-icon.svg',
    },
  ];
  chatTypeArrayNew: any = [
    // {
    //   text: 'Your inbox',
    //   chat_type: 3,
    //   new_msg_count: 0,
    //   icon: 'assets/images/chatbot/inbox-icon.svg',
    // },
    // {
    //   text: 'Unassigned Chats',
    //   chat_type: 2,
    //   new_msg_count: 0,
    //   icon: 'assets/images/chatbot/chat-unread.svg',
    // },
    // { text: 'All Chats', chat_type: 1, new_msg_count: 0,icon: 'assets/images/chatbot/inbox-icon.svg' },
    {
      text: 'Active Teammates',
      chat_type: 4,
      new_msg_count: 0,
      icon: 'assets/images/chatbot/Users_Group.png',
    },
    {
      text: 'Website',
      chat_type: 5,
      new_msg_count: 0,
      icon: 'assets/images/chatbot/inbox-icon.svg',
    },
  ];

  chat_type: any = 1;
  read_type: any = 1;
  current_chat_type: any = 'Business';
  // Chatbot Variables
  @Output() refreshTicket: any = new EventEmitter();
  @ViewChild('updateTicket') public updateTicket: any;
  @ViewChild('previewImageMeModal') public previewImageMeModal: any;
  @ViewChild('uploadAttachment', { static: false }) uploadAttachment: any;
  @ViewChild('textareaFocused', { static: false }) textareaFocused: any;
  @ViewChild('scrollMe') private myScrollContainer: any;
  @ViewChild('ssnModal') ssnModal: any;
  @ViewChild('show_filters') public show_filters: any;
  @ViewChild('viewDocModal') public viewDocModal: any;
  @ViewChild('assignToMeModal') public assignToMeModal: any;
  @ViewChild('rightSideBar') public rightSideBar: any;
  @ViewChild('globalRightSidebar') public globalRightSidebar: any;
  @ViewChild('globalChatListing') public globalChatListing: any;
  adminData: any;
  is_first_msg: any = false;
  activeList: any = 1;
  ticketList: any = [];
  selfTickets: any = [];
  current_admin: any;
  active_chat: any;
  enableChat: any = false;
  initiatedSocket: boolean = false;
  disableInput: boolean = false;
  public userUpdatedStatus = 'Away';
  chat_message: any = '';
  static_message: any = 'You have an important notification from recuvery.';
  public file: any = {};
  messages: any = [];
  filesArr: any = [];
  preview_data: any = [];
  animationElm: boolean = false;
  checkSupportMsgStatus: any = true;
  scrollPosition: any = 0;
  old_height: any = 0;
  notification_type: any = 1;
  update_status: string = '';
  note: any = '';
  dynamic_msg: any = '';
  initChat: any;
  userReply: any = '';
  booster_purchased: any = false;
  subscription: any;
  subscription2: any;
  unreadData: any;
  UserDetailSelectedTab: number = 0;
  userDetailsData: any;
  showSSN: boolean = false;
  _ssnData: any;
  ssnShowType: any;
  ssnForm: any;
  show: boolean = false;
  chat_status: any = 1;
  user_status_filter: any = 1;
  userType: any = 1;
  start_date: any = new Date(2024, 5, 1);
  end_date: any = new Date();
  bsConfig = {
    showWeekNumbers: false,
    dateInputFormat: 'MM/DD/YYYY',
    selectFromOtherMonth: true,
  };
  search: any;
  docList: any;
  doc_url: any;
  offset: any = 0;
  limit: any = 50;
  modalRef?: BsModalRef;
  mainData: any = {};
  new_data_length: any = 0;
  show_unread_msg: boolean = true;
  show_selected_chat: boolean = false;
  selected_filter: any = [];
  filter_apply: boolean = false;
  assigned_id: number = 0;
  show_chat: boolean = false;
  show_listing: boolean = false;
  yourInboxData: any[] = [];
  user_id: any;
  admin_chat_timer: any;
  visitorChatData: any;
  selectedWsChat: number = 1;
  type: number = 0;
  get timezoneVal(): any {
    return this.timezone;
  }
  @Input() set timezoneVal(val: any) {
    this.timezone = val;
  }
  subs: Subscription[] = [];
  public ticket_id: any;
  get ticketId(): string {
    return this.ticket_id;
  }
  chatEnabled = false;
  public ticket_status: any;
  get ticketStatus(): Number {
    return this.ticket_status;
  }
  @Input() set ticketStatus(val: Number) {
    if (val) {
      this.ticket_status = val;
    }
  }
  selected_admin_name: string = '';
  @Input() global_bar: boolean = true;
  show_filters_drop = false;
  search_admin: string = '';
  constructor(
    public socket: ChatSupportService,
    private router: Router,
    private datePipe: DatePipe,
    fb: FormBuilder,
    private route: ActivatedRoute,
    public _shared: SharedService,
    private _api: ApiService,
    private _local: localStorageService,
    public _main: MainService,
    public _socketService: SocketsService
  ) {
    this.ssnForm = fb.group({
      password: fb.control('', Validators.required),
      notes: fb.control('', Validators.required),
    });

    
   // Fetch the current URL path
   const currentPath = this.router.url.split('?')[0]; // Removes query parameters    
    if (currentPath == '/app/chatsupport') {
      this.global_bar = false;
      this._main.global_bar = false;
    }
  }

  ngOnInit(): void {
    let profileData: any = this._local.customGetItem('admin_profile');
    this.current_admin = profileData.admin_id;
    this.adminData = profileData;
    // this.subscription2 = this.service
    //   .getCurrentTimezone()
    //   .subscribe((value: any) => {
    //     this.timezone = value.timezone;
    //     this.timezoneName = value.name;
    //     this.socket.getSupportChatData();
    //     this.recentChat();
    //   });

    // this.subscription = this.service
    // .getMessage()
    // .subscribe((value: any) => {
    //   this.socket.getSupportChatData();
    //   this.recentChat();
    // });

    this.route.queryParams.subscribe((res) => {
      if (res['chat_type']) {
        let index = this.chatTypeArray.findIndex(
          (dt: any) => dt.chat_type == res['chat_type']
        );
        this.chat_type = this.chatTypeArray[index].chat_type;
        this.current_chat_type = this.chatTypeArray[index].text;
      }

      if (res['user_id']) {
        this.search = res['user_id'];
        this.user_id = res['user_id'];
      }
    });

    this.socket.message_open$.subscribe((dt: any) => {
      if (dt && dt.message && dt.message.redirection_type == 10) {
        this._shared.playNotificationSound();
        this.recentChat();
      //   let parsed_data = JSON.parse(JSON.parse(dt.message.metadata));
      //   if (localStorage.getItem('is_dummy') == parsed_data.is_dummy) {
      //     this.chatTypeArray[1].new_msg_count++;
      //     this.chatTypeArrayNew[1].new_msg_count++;
      //   }
      //   let parsedData = JSON.parse(dt.message.metadata);
      //   let parse_2 = JSON.parse(parsedData);

      // } else if (dt && dt['key'] == 'update_count') {
      //   if (this.chatTypeArray[1].new_msg_count > 0) {
      //     this.chatTypeArray[1].new_msg_count--;
      //   }
      //   this.chatTypeArray[0].new_msg_count++;

      //   if (this.chatTypeArrayNew[1].new_msg_count > 0) {
      //     this.chatTypeArrayNew[1].new_msg_count--;
      //   }

      //   this.chatTypeArrayNew[0].new_msg_count++;
      // } else if (dt && dt['key'] == 'update_count_inbox') {
      //   this.chatTypeArray[0].new_msg_count++;
      //   this.chatTypeArrayNew[0].new_msg_count++;
      }
    });

    this.socket.adminChatRefresh.subscribe((data) => {
      data['update_counter'] = 1;
      if (data.ticketId) {
        this.changeOrder(data);
      }
    });

    this.socket.changeOrder.subscribe((data) => {
      if (data.ticketId) {
        this.changeOrder(data);
      }
    });

    this.socket.supportChatData.subscribe((data) => {
      this.yourInboxData = data;
    });

    this.socket.openGlobalChat.subscribe((data) => {
      console.log(data, 'datatatat===');
      if (data.req_id) {
        this.recentStats(data, 3);
      } else {
        this.socket.selected_chat.emit(data);
        this.globalRightSidebar.show();
        this.socket.openChat(this.userId);
      }
    });

    this.socket.userChatData.subscribe((data) => {
      console.log(data, 'daataa-----userChatData');

      if (data.ticketList && data.ticketList.length > 0) {
        this.unreadData = data;
        // this.chatTypeArray[0].new_msg_count = data.your_chats_count;
        // this.chatTypeArray[1].new_msg_count = data.unassigned_chats_count;

        // this.chatTypeArrayNew[0].new_msg_count = data.your_chats_count;
        // this.chatTypeArrayNew[1].new_msg_count = data.unassigned_chats_count;
        this.new_data_length = data.ticketList.length;
        if (this.type == 1) {
          this.recentchatData = [...this.recentchatData, ...data.ticketList];
        } else {
          this.recentchatData = data.ticketList;
          this.userData = this.recentchatData[0];
        }

        console.log(this.recentchatData,"v--------");
        

        this.type = 0;

        //New Code
        let allAdmins: any = [];
        allAdmins.push({
          value: this.adminData.admin_id.toString(),
          label: this.adminData.admin_name + ' (Me)',
        });

        this.unreadData.teammates.forEach((element: any) => {
          if (
            this.adminData.admin_id.toString() !== element.admin_id.toString()
          ) {
            allAdmins.push({
              value: element.admin_id.toString(),
              label: element.admin_name,
            });
          }
        });
        this.socket.agent_list = [...allAdmins];
      } else {
        this.unreadData = [];
        this.unreadData['unReadMsgCount'] = 0;
        if (this.type == 0) {
          this.recentchatData = [];
          this.messages = [];
          this.active_chat = false;
          this.userdataStats = '';
          this.booster_purchased = '';
          this.userDetailsData = '';
          this.docList = [];
          this.activeUserId = 0;
          this.unreadData['unReadMsgCount'] = 0;
        }
      }
    });

    this.socket.getSupportChatData();
    // this.wordPressChat(1);
    this.recentChat();
  }

  ngAfterViewChecked() {
    if (this.myScrollContainer && this.myScrollContainer.nativeElement) {
      if (
        this.old_height != this.myScrollContainer.nativeElement.scrollHeight
      ) {
        this.old_height = this.myScrollContainer.nativeElement.scrollHeight;
        this.scrollToElement();
      }
    }
  }

  scrollToElement(): void {
    this.myScrollContainer.nativeElement.scroll({
      top: this.myScrollContainer.nativeElement.scrollHeight,
      left: 0,
      behavior: 'smooth',
    });
  }

  recentStats(data?: any, key?: any) {
    console.log(data, 'data=-====');

    this.globalChatListing.hide();
    this.ticket_id = data.req_id;
    this.socket.recentchatData = this.recentchatData;

    this.socket.selected_chat.emit(data);
    this.socket.getAdminGroupChatData(data.req_id);

    this.admin_chat_timer = setInterval(() => {
      this.socket.getAdminGroupChatData(data.req_id);
    }, 10000);

    if (key == 3) {
      // this.socket.recentchatData = this.yourInboxData;
      let index = this.yourInboxData.findIndex(
        (elem: any) =>
          elem.req_id == data.req_id && elem.assigned_id == this.current_admin
      );
      if (index != -1) {
        if (this.yourInboxData[index].new_msg_count > 0) {
          this.yourInboxData[index].new_msg_count = 0;
        }
      }
    } else {
      let index = this.recentchatData.findIndex(
        (elem: any) =>
          elem.req_id == data.req_id && elem.assigned_id == this.current_admin
      );
      if (index != -1) {
        if (this.recentchatData[index].new_msg_count > 0) {
          this.recentchatData[index].new_msg_count = 0;
        }
      }
    }

    if (key == 2 || key == 3) {
      this.globalRightSidebar.show();
    } else {
      this.rightSideBar.show();
    }
  }

  userLiveStatus(user_id: any) {
    this.sub2 = this.socket.userLiveStatus.subscribe((data) => {
      if (data.user_id == user_id) {
        this.user_status = data.status;
      }
    });
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  updatePanel(dt:any) {
    this._socketService.panel_type = dt.panel_type;
    this.current_chat_type = dt.text;
    this.reset_filter();
  }
  
  updateChats(chat: any) {
    this._shared.stopNotificationSound();
    this.chat_type = chat;
    this.selected_admin_name = '';
    this.reset_filter();
  }

  reset_filter() {
    this.chat_status = 1;
    this.user_status_filter = 1;
    this.userType = 1;
    this.start_date = new Date(2024, 5, 1);
    this.end_date = new Date();
    this.search = '';
    this.offset = 0;
    // this.filter_apply = false;
    this.assigned_id = 0;
    this.recentChat();
  }

  onScrollDown() {
    if (this.new_data_length >= this.limit && this.chat_type !== 5) {
      this.recentChat(1);
    }
  }

  readUnread(type: any) {
    this.readChatShow = !this.readChatShow;
    this.read_type = type;
    this.recentChat();
  }

  recentChat(type?: any) {
    if (this.start_date > this.end_date) {
      this._shared.customPopups(
        'End date should be greater than start date',
        1
      );
      return;
    }

    if (type == 1) {
      this.type = 1;
      this.offset += 50;
    } else {
      this.type = 0;
    }

    if (!this.filter_apply && this.chat_type == 3) {
      this.chat_status = 2;
      this.filter_apply = true;
    }

    let body: any = {
      chat_type: this.chat_type, //1- All, 2- Unassigned, 3- Yours
      read_type: this.read_type, //1- All, 2- unread
      search_string: this.search,
      user_status: this.user_status_filter, //1- All, 2- Online, 3- Offline
      chat_status: this.chat_status, //1- All, 2- Active-Reopen, 3- Closed
      userType: this.userType, //1- All, 2- Pro User, 3- Free User,
      start_date: this.datePipe.transform(this.start_date, 'MM/dd/yyyy'),
      end_date: this.datePipe.transform(this.end_date, 'MM/dd/yyyy'),
      offset: this.offset,
      limit: this.limit,
      assigned_id: this.assigned_id,
      search_admin: this.search_admin,
    };

    if (this.user_id) {
      body['user_id'] = this.user_id;
    }

    if (body.assigned_id !== 0) {
      body['chat_type'] = 1;
      body['chat_status'] = 1;
    }


    console.log(body,"body----");
    
    this.handle_filters(body);
    this.socket.getUserData(body);
  }

  handle_filters(body: any) {
    this.selected_filter = [];

    if (body.user_status != 1) {
      this.selected_filter.push({
        key: 'user_status',
        value: body.user_status == 2 ? 'Online' : 'Offline',
      });
    }

    if (body.chat_status != 1) {
      this.selected_filter.push({
        key: 'chat_status',
        value: body.chat_status == 2 ? 'Active-Reopen' : 'Closed',
      });
    }
  }

  remove_filter(dt: any) {
    this.selected_filter.pop((d: any) => d.key == dt.key);
    if (dt.key == 'userType') {
      this.userType = 1;
    } else if (dt.key == 'chat_status') {
      this.chat_status = 1;
    } else if (dt.key == 'user_status') {
      this.user_status_filter = 1;
    }

    this.recentChat();
  }

  export_chat() {
    this._api
      .downloadApi(
        { ticket_id: this.ticketId.toString() },
        'chatbot/download_zip',
        0
      )
      .subscribe(
        (data: any) => {
          console.log(data);
        }
      );
  }

  changeOrder(data: any) {
    let index = this.recentchatData.findIndex(
      (elem: any) =>
        elem.req_id == data.ticketId && elem.assigned_id == this.current_admin
    );

    console.log(index, 'inde');

    if (index != -1) {
      let selectedObject = this.recentchatData.splice(index, 1)[0];
      selectedObject['note'] = data.message;
      if (data.update_counter == 1 && this.ticket_id != data.ticketId) {
        selectedObject['new_msg_count']++;
      }
      console.log(selectedObject, 'selectedObject----');

      this.recentchatData.unshift(selectedObject);
    }

    if (data.key == 2) {
      this.recentchatData.unshift(this.recentchatData[index]);
    }

    this.socket.getSupportChatData();
  }

  redirectV2(key_val: any, key: number) {
    let url;
    if (key == 1) {
      url = this.router.serializeUrl(
        this.router.createUrlTree([`/users/view/${key_val}`], {
          queryParams: {
            open_chat: 1,
          },
        })
      );
    } else if (key == 2) {
      url = this.router.serializeUrl(
        this.router.createUrlTree([`/assignments/view/${key_val}`])
      );
    } else if (key == 4) {
      url = this.router.serializeUrl(
        this.router.createUrlTree([`/assignments/chatsupport`])
      );
    }

    window.open(url, '_blank');
  }

  isNewMessage(lastMsgTime: string): boolean {
    const lastMsgDate = moment(lastMsgTime);
    const currentTime = moment();

    // Calculate the difference in minutes
    const diffInMinutes = currentTime.diff(lastMsgDate, 'minutes');

    return diffInMinutes <= 15; // Return true if the difference is 15 minutes or less
  }

  //GLOBAL SIDEBAR CODE

  updateChatsGlobal(chat: any) {
    this.chat_type = chat.chat_type;
    this.current_chat_type = chat.text;
    this.selected_admin_name = '';
    if (chat.chat_type !== 4) {
      this.reset_filter();
    }
    this.globalChatListing.show();
  }

  getInitials(name: string) {
    if (name) {
      const nameParts = name.trim().split(' ').filter(Boolean);
      if (nameParts.length >= 2) {
        // Take the first letter of the first and last name
        return nameParts[0][0] + nameParts[nameParts.length - 1][0];
      } else if (nameParts.length === 1) {
        // For a single name, take the first two letters
        return nameParts[0][0] + nameParts[0][1];
      }
    } else {
      if (this.chat_type == 5) {
        return 'GU';
      }
      return 'CC';
    }
    return false;
  }

  getAdminTicketList(dt: any) {
    this.assigned_id = dt.admin_id;
    this.selected_admin_name = dt.admin_name;
    this.chat_type = 1;
    this.current_chat_type = 'All Chats';
    this.recentChat();
  }

  leaveAdmin() {
    if (this.ticket_id) {
      this.socket.leaveAdmin(this.ticket_id, this.adminData.admin_id);
      setTimeout(() => {
        this.socket.getAdminGroupChatData(this.ticket_id);
      }, 3000);
    }

    clearInterval(this.admin_chat_timer);
  }
}
